<template>
  <BCard>
    <div class="flex flex-row justify-between">
      <div class="flex flex-row items-center gap-7">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt="Komerce"
          class="cursor-pointer"
          @click="$router.back()"
        >
        <div class="text-black font-medium text-2xl">
          Detail Berkas
        </div>
      </div>
      <div class="d-flex gap-5">
        <div v-if="data.status === 'requested'">
          <BButton
            variant="outline-primary"
            size="small"
            style="border-radius: 25px !important"
            @click="$bvModal.show('modal-rules')"
          >
            Petunjuk Verifikasi
            <BIcon icon="question-circle" />
          </BButton>
        </div>
        <div
          v-else
          class="flex items-center gap-4"
        >
          <div>{{ DAY_MONTH_YEAR(data.last_updated) }} | {{ TIME(data.last_updated) }}</div>
          <div :class="getClassStatus(data.status)">
            {{ getLabelStatus(data.status) }}
          </div>
        </div>
        <a
          :href="`https://analytics.komerce.id/dashboard/3-data-partners?tab=8-orders&partner_id=${partnerInfo.partner_user_id}&user_id=&email=&nik=&hp=&hp_bisnis=&shipping=&card_id=&order_created_at=&order_updated_at=&status=&status_retur=&payment_method=COD&payment_method=BANK%20TRANSFER&monthly_spending=past2months~`"
          target="_blank"
          :class="data.status === 'requested' ? 'btn' : ''"
          class="px-1 py-[5px] text-center text-white rounded-md bg-primary cursor-pointer"
        >
          Lihat Data
        </a>
      </div>
    </div>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <ValidationObserver #default="{ invalid }">
        <BRow>
          <BCol
            v-for="file in files"
            :key="file.key"
            lg="4"
          >
            <BCard body-class="flex flex-col gap-3">
              <div>
                <div class="text-black text-lg font-medium">
                  {{ file.label }}
                  <span :class="file.statusClass">
                    ({{ file.status }})
                  </span>
                </div>
              </div>
              <img
                :src="file.img"
                alt="Komerce"
                class="rounded-xl w-full h-56 object-contain"
              >
              <span v-if="file.isRequested">
                <div class="text-sm text-center my-1">
                  <ValidationProvider
                    #default="{ errors }"
                    :name="`radio-${file.key}`"
                    rules="required"
                  >
                    <BFormRadioGroup
                      v-model="selected[file.key]"
                      :state="errors.length > 0 ? false : null"
                      :options="options"
                    />
                  </ValidationProvider>
                </div>
                <BFormGroup
                  invalid-feedback="Silahkan isi catatan"
                >
                  <label
                    :for="`reason-${file.key}`"
                    class="text-lg text-black"
                  >
                    Alasan
                  </label>
                  <ValidationProvider
                    #default="{ errors }"
                    :name="`notes-${file.key}`"
                    :rules="selected[file.key] === false ? 'required' : ''"
                  >
                    <BFormTextarea
                      :id="`reason-${file.key}`"
                      v-model="notes[file.key]"
                      debounce="300"
                      placeholder="Tuliskan alasan kamu jika menolak"
                      rows="4"
                      :formatter="maxLength"
                      :state="errors.length > 0 ? false : null"
                    />
                  </ValidationProvider>
                  <BRow class="justify-content-end">
                    <small class="mr-1 mt-50">
                      {{ (notes[file.key] || '').length }}/300 karakter
                    </small>
                  </BRow>
                </BFormGroup>
              </span>
              <BFormTextarea
                v-else-if="file.isRejected"
                v-model="file.notes"
                disabled
                rows="4"
                class="mt-1"
              />
            </BCard>
          </BCol>
        </BRow>
        <BRow>
          <BCol lg="12">
            <div class="flex flex-row items-center">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user.svg"
                alt="Komerce"
              >
              <div class="ml-[10px]">
                <h5 class="text-black font-medium text-xl mb-0">
                  Informasi Data Partner
                </h5>
                <div>
                  <sup class="text-primary">*</sup>
                  <span>Pastikan dokumen yang di-upload persis dengan informasi data partner</span>
                </div>
              </div>
            </div>
          </BCol>
        </BRow>
        <BOverlay
          :show="loadingPartnerInfo"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <BRow class="justify-center items-center mt-3 gap-[10px]">
            <BCol
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                Pengguna Product
              </BCol>
              <BCol
                lg="6"
                class="flex items-center"
              >
                <div
                  v-for="(product, key) in partnerInfo.products"
                  :key="key"
                >
                  <img
                    :src="product.url_image"
                    alt="Komerce"
                    width="30"
                  >
                </div>
              </BCol>
            </BCol>
            <BCol
              v-for="(field, index) in formFields"
              :key="index"
              lg="12"
              class="flex items-center"
            >
              <BCol
                lg="4"
                class="text-lg"
              >
                {{ field.label }}
              </BCol>
              <BCol lg="6">
                <BInput
                  v-model="field.value"
                  disabled
                />
              </BCol>
            </BCol>
          </BRow>
        </BOverlay>
        <BRow
          v-if="data.status === 'requested'"
          class="justify-end px-2 gap-7 mt-2"
        >
          <BButton
            variant="outline-primary"
            @click="$router.back()"
          >
            Kembali
          </BButton>
          <BButton
            :disabled="invalid || isFormInvalid"
            :variant="invalid || isFormInvalid ? 'secondary' : 'primary'"
            @click="$bvModal.show('modal-verification-kyc')"
          >
            Konfirmasi
          </BButton>
        </BRow>
      </ValidationObserver>
    </BOverlay>
    <BModal
      id="modal-verification-kyc"
      ref="modal-verification-kyc"
      no-stacking
      centered
      hide-footer
      hide-header
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <div
        v-if="loadingSubmit"
        class="modal-loader-container mt-2"
      >
        <div class="loader-wrapper">
          <div class="loader" />
          <div class="progress-text">
            {{ submitProgress }}%
          </div>
        </div>
        <div class="mt-1 text-lg text-center text-black">
          Sedang memproses verifikasi...
        </div>
      </div>
      <BRow
        v-else
        class="justify-center my-1 flex flex-column"
      >
        <BCol class="d-flex justify-content-center">
          <BImg
            src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          />
        </BCol>
        <BCol class="d-flex justify-content-center mt-1">
          <div class="font-medium text-black text-xl">
            Konfirmasi Verifikasi
          </div>
        </BCol>
        <BCol class="d-flex justify-content-center my-1">
          <div class="font-normal text-black text-base text-center">
            Apakah kamu yakin akan mengubah status verifikasi ini?
          </div>
        </BCol>
        <BRow class="flex flex-row justify-center gap-3 mx-2">
          <BCol class="d-flex justify-content-center">
            <BButton
              block
              size="md"
              variant="outline-primary"
              @click="$bvModal.hide('modal-verification-kyc')"
            >
              Tidak
            </BButton>
          </BCol>
          <BCol class="d-flex justify-content-center">
            <BButton
              block
              size="md"
              :variant="loadingSubmit ? 'secondary' : 'primary'"
              :disabled="loadingSubmit"
              @click="onSubmit"
            >
              Iya
            </BButton>
          </BCol>
        </BRow>
      </BRow>
    </BModal>

    <Rules />
    <ModalWarning :meta-message="metaMessage" />
  </BCard>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { newAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'
import { DAY_MONTH_YEAR, TIME } from '@/libs/filterDate'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import Rules from './Rules.vue'
import {
  optionsRadioSelfie, getClass, getLabelStatus, getClassStatus,
} from './config'
import ModalWarning from './ModalWarning.vue'

export default {
  components: {
    Rules, ValidationProvider, ValidationObserver, ModalWarning,
  },
  data() {
    return {
      isEmpty,
      required,
      getClass,
      getLabelStatus,
      getClassStatus,
      DAY_MONTH_YEAR,
      TIME,
      loading: false,
      loadingSubmit: false,
      loadingPartnerInfo: false,
      options: optionsRadioSelfie,
      selected: {
        ktp_face_picture: true,
        ktp_picture: false,
        liveness_picture: false,
      },
      notes: {
        ktp_face_picture: '',
        ktp_picture: '',
        liveness_picture: '',
      },
      idVerif: this.$route.params.id,
      partnerId: this.$route.params.id_partner,
      data: {},
      alertError,
      alertSuccess,
      partnerInfo: {},
      submitProgress: 0,
      progressInterval: null,
      metaMessage: '',
    }
  },
  computed: {
    formFields() {
      const data = [
        {
          label: 'Email',
          value: this.data.info_data_partner.email,
        },
        {
          label: 'No.Ponsel',
          value: this.data.info_data_partner.phone,
        },
        {
          label: 'Nama',
          value: this.data.info_data_partner.name,
        },
        {
          label: 'NIK',
          value: this.data.info_data_partner.nik,
        },
        {
          label: 'Tempat Lahir',
          value: this.data.info_data_partner.birth_place,
        },
        {
          label: 'Tanggal Lahir',
          value: moment(this.data.info_data_partner.birth_date, 'DD-MM-YYYY').format('DD MMMM YYYY'),
        },
        {
          label: 'Provinsi',
          value: this.data.info_data_partner.province,
        },
        {
          label: 'Kabupaten/Kota',
          value: this.data.info_data_partner.city,
        },
        {
          label: 'Kecamatan',
          value: this.data.info_data_partner.district,
        },
        {
          label: 'Kelurahan/Desa',
          value: this.data.info_data_partner.village,
        },
        {
          label: 'Alamat',
          value: this.data.info_data_partner.address,
        },
        {
          label: 'RT/RW',
          value: this.data.info_data_partner.rt_rw,
        },
        {
          label: 'Kode Pos',
          value: this.data.info_data_partner.pos_code,
        },
      ]

      return data
    },
    files() {
      return [
        {
          key: 'ktp_face_picture',
          label: 'Foto wajah beserta KTP',
          statusClass: this.getClass(this.data.ktp_face_picture?.status),
          status: this.getLabelStatus(this.data.ktp_face_picture?.status),
          img: this.data?.ktp_face_picture?.url,
          notes: this.data?.ktp_face_picture?.notes,
          isRequested: this.data.ktp_face_picture?.status === 'requested',
          isRejected: this.data.ktp_face_picture?.status === 'rejected',
        },
        {
          key: 'liveness_picture',
          label: 'Verifikasi Wajah',
          statusClass: this.getClass(this.data?.liveness_picture?.status),
          status: this.getLabelStatus(this.data?.liveness_picture?.status),
          img: this.data?.liveness_picture?.url,
          notes: this.data?.liveness_picture?.notes,
          isRequested: this.data?.liveness_picture?.status === 'requested',
          isRejected: this.data?.liveness_picture?.status === 'rejected',
        },
        {
          key: 'ktp_picture',
          label: 'Foto KTP',
          statusClass: this.getClass(this.data.ktp_picture?.status),
          status: this.getLabelStatus(this.data.ktp_picture?.status),
          img: this.data?.ktp_picture?.url,
          notes: this.data?.ktp_picture?.notes,
          isRequested: this.data?.ktp_picture?.status === 'requested',
          isRejected: this.data?.ktp_picture?.status === 'rejected',
        },
      ]
    },
    isFormInvalid() {
      const requestedFiles = this.files.filter(file => file.isRequested)

      if (requestedFiles.length === 0) return false

      // eslint-disable-next-line no-restricted-syntax
      for (const file of requestedFiles) {
        const isRejected = this.selected[file.key] === false
        const notesEmpty = !this.notes[file.key] || this.notes[file.key].trim() === ''

        if (isRejected && notesEmpty) {
          return true
        }
      }

      return false
    },
  },
  watch: {
    'selected.liveness_picture': function () {
      if (this.selected.liveness_picture === true && this.selected.ktp_face_picture === true) {
        this.selected.ktp_picture = true
      } else if (this.selected.liveness_picture === false || this.selected.ktp_face_picture === false) {
        this.selected.ktp_picture = false
      }
    },
    'selected.ktp_face_picture': function () {
      if (this.selected.liveness_picture === true && this.selected.ktp_face_picture === true) {
        this.selected.ktp_picture = true
      } else if (this.selected.liveness_picture === false || this.selected.ktp_face_picture === false) {
        this.selected.ktp_picture = false
      }
    },
  },
  mounted() {
    this.getLatestHistory()
    this.getPartnerInfo()
  },
  methods: {
    async getLatestHistory() {
      this.loading = true
      const url = `/auth/api/v1/admin/ktp-verification/${this.idVerif}/latest-history`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$toast_error({ message: 'Gagal loda data' })
        })
    },
    startProgressLoader() {
      this.submitProgress = 0
      this.progressInterval = setInterval(() => {
        if (this.submitProgress < 100) {
          this.submitProgress = Math.min(this.submitProgress + 1, 100)
        }
      }, 1000) // Update setiap 1 detik
    },
    clearProgressLoader() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }
      this.loadingSubmit = false
      this.submitProgress = 0
    },
    async onSubmit() {
      this.loadingSubmit = true
      this.startProgressLoader()

      const payload = {
        picture_ktp_with_face: {
          notes: this.notes.ktp_face_picture,
          is_approval: this.selected.ktp_face_picture,
        },
        picture_ktp: {
          notes: this.notes.ktp_picture,
          is_approval: this.selected.ktp_picture,
        },
        liveness: {
          notes: this.notes.liveness_picture,
          is_approval: this.data.liveness_picture.status === 'approved' ? true : this.selected.liveness_picture,
        },
      }

      const url = `/auth/api/v1/admin/ktp-verification/${this.idVerif}/approval`

      try {
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => {
            reject(new Error('Request timeout after 30 seconds'))
          }, 30000) // 30 detik timeout
        })

        await Promise.race([
          await newAxiosIns.post(url, payload),
          timeoutPromise,
        ])

        this.clearProgressLoader()
        this.$bvModal.hide('modal-verification-kyc')
        this.$router.push('/verification-ktp')
        this.alertSuccess('Kamu berhasil mengupdate berkas pengajuan verifikasi KTP')
      } catch (error) {
        this.clearProgressLoader()
        this.$bvModal.hide('modal-verification-kyc')

        if (error.response.data.meta.message === 'identity data mismatched') {
          this.$bvModal.show('modal-warning')
          this.metaMessage = 'dukcapil'
          this.getLatestHistory()
        }
        if (error.response.data.meta.message === 'user already registered in bank') {
          this.$bvModal.show('modal-warning')
          this.metaMessage = 'monit'
        }

        if (error.response && error.response.data && error.response.data.data) {
          const { response: { data: { data } } } = error

          if (data.error_ktp && data.error_ktp.length > 0) {
            const numberedErrors = data.error_ktp.map((err, idx) => `${idx + 1}. ${err.message}`)
            this.notes.ktp_picture = numberedErrors.join('\n')
            this.selected.ktp_picture = false
          }

          if (data.error_face_ktp && data.error_face_ktp.length > 0) {
            const numberedErrors = data.error_face_ktp.map((err, idx) => `${idx + 1}. ${err.message}`)
            this.notes.ktp_face_picture = numberedErrors.join('\n')
            this.selected.ktp_face_picture = false
          }

          this.$toast_error({ message: 'Ada kesalahan saat update berkas pengajuan verifikasi KTP' })
        } else {
          this.$toast_error({ message: 'Terjadi kesalahan jaringan. Silakan coba lagi.' })
        }
      }
    },
    async getPartnerInfo() {
      this.loadingPartnerInfo = true
      const url = `/auth/api/v1/admin/ktp-verification/user/${this.partnerId}/info`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.loadingPartnerInfo = false
          this.partnerInfo = data
        })
        .catch(() => {
          this.loadingPartnerInfo = false
          this.$toast_error({ message: 'Gagal load data info partner' })
        })
    },
    maxLength(e) {
      return String(e).substring(0, 300)
    },
    handleChange(evt, key) {
      this.selected[key] = evt
    },
    handleVisibleStatus(status) {
      if (status === 'approved') return false
      return true
    },
  },
}
</script>
<style scoped lang="scss">
@import './verification.scss';
</style>
